import { useCallback, useState } from "react";

import { checkAssignmentMember } from "@type/api/businessUnit";

import { TCheckAssignmentMemberReq } from "@type/api/businessUnit/types";

export const useCheckMemberAssignment = () => {
  const [loadingCheckMemberAssignment, setLoadingCheckMemberAssignment] =
    useState(false);
  const handleCheckMemberAssignment = useCallback(
    async (payload: TCheckAssignmentMemberReq) => {
      setLoadingCheckMemberAssignment(true);
      return checkAssignmentMember(payload)
        .then((res) => {
          return res.data.hasAssignment;
        })
        .finally(() => {
          setLoadingCheckMemberAssignment(false);
        });
    },
    []
  );

  return {
    loadingCheckMemberAssignment,
    onCheckMemberAssignment: handleCheckMemberAssignment,
  };
};
